
import { useState, useEffect } from 'react';
import { CookiePreferences } from '@/types/cookie-consent';

const COOKIE_PREFERENCES_KEY = 'cookie-preferences';

const defaultPreferences: CookiePreferences = {
  necessary: true, // Always required
  functional: false,
  analytics: false,
  marketing: false,
  lastUpdated: new Date().toISOString(),
};

export const useCookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [preferences, setPreferences] = useState<CookiePreferences>(defaultPreferences);

  useEffect(() => {
    const storedPreferences = localStorage.getItem(COOKIE_PREFERENCES_KEY);
    if (!storedPreferences) {
      setShowBanner(true);
    } else {
      setPreferences(JSON.parse(storedPreferences));
    }
  }, []);

  const savePreferences = (newPreferences: CookiePreferences) => {
    const preferencesWithTimestamp = {
      ...newPreferences,
      lastUpdated: new Date().toISOString(),
    };
    localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(preferencesWithTimestamp));
    setPreferences(preferencesWithTimestamp);
    setShowBanner(false);
  };

  const resetPreferences = () => {
    localStorage.removeItem(COOKIE_PREFERENCES_KEY);
    setPreferences(defaultPreferences);
    setShowBanner(true);
  };

  return {
    showBanner,
    preferences,
    savePreferences,
    resetPreferences,
  };
};
